import { render, staticRenderFns } from "./TowerSettingsDeliveryTime.vue?vue&type=template&id=d771fb28"
import script from "./TowerSettingsDeliveryTime.vue?vue&type=script&lang=js"
export * from "./TowerSettingsDeliveryTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports